import React, { useEffect, useRef, useState } from 'react'
import Layout from '../common/Layout'
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from 'react-hook-form';
import ApiHelper from '../../helperFunction/ApiHelper';
import API_ENDPOINTS from '../../helperFunction/Constant';
import { Toast } from 'primereact/toast';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { TabPanel, TabView } from 'primereact/tabview';
import AddSections from './AddSections';
import AddQuestions from './AddQuestions';

const AddQuiz = () => {

    const { id } = useParams()
    const isEdit = id ? true : false
    const toast = useRef(null)
    const navigate = useNavigate()

    const [quizData, setQuizData] = useState([])

    useEffect(() => {
        isEdit && getQuizData()
    }, [])

    const schema = yup.object({
        quizName: yup.string().required("Quiz Name is required"),
        quizDescription: yup.string().required("Description is required"),
        subtitle: yup.string().required("Subtitle is required"),
        thumbnail: yup.mixed().test("image-required", "Thumbnail is required", function (value) { return ((value && value.length > 0) || quizData?.thumbnail); }),
        isActive: yup.boolean(),
    });

    const { register, handleSubmit, reset, resetField, watch, formState: { errors }, } = useForm({ resolver: yupResolver(schema), });

    const resetValue = () => {
        reset({
            quizName: '',
            quizDescription: '',
            subtitle: '',
            thumbnail: null,
            isActive: '',
        })
    }

    const previewImage = watch('thumbnail')

    const getQuizData = (data) => {
        ApiHelper.get(`${API_ENDPOINTS.QUIZ}/${id}`, data).then((res) => {
            if (res.status === 200) {
                setQuizData(res.data.data)
                reset({
                    quizName: res.data.data.quizName,
                    quizDescription: res.data.data.quizDescription,
                    subtitle: res.data.data.subtitle,
                    isActive: res.data.data.isActive,
                })
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };

    const onSubmit = (data) => {
        const formData = new FormData()
        for (const [key, value] of Object.entries(data)) {
            formData.append(key, value);
        };
        if (data.thumbnail) {
            formData.append('thumbnail', data.thumbnail[0]);
        }
        if (isEdit) {
            update(formData)
        } else {
            add(formData)
        }
    };

    const add = (data) => {
        ApiHelper.post(`${API_ENDPOINTS.QUIZ}/`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setTimeout(() => {
                    navigate('/quiz')
                }, 1500)
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };

    const update = (data) => {
        ApiHelper.put(`${API_ENDPOINTS.QUIZ}/${id}`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setTimeout(() => {
                    navigate('/quiz')
                }, 1500)
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };

    const confirmDeleteDailog = () => {
        confirmDialog({
            message: 'Do you want to delete this record?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            defaultFocus: null,
            acceptClassName: 'p-button-danger',
            accept: () => deleteImage(),
        });
    };

    const deleteImage = () => {
        ApiHelper.post(`${API_ENDPOINTS.QUIZ}/delete-image/${id}`).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 });
                getQuizData();
            }
        }).catch((err) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: err.response?.data?.message, life: 3000 });
        });
    };

    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />
            <Layout>
                <div class="content-wrapper">
                    <div class="container-xxl flex-grow-1 container-p-y">
                        <div class="d-flex justify-content-between align-items-center py-3">
                            <h4 class="fw-bold py-3 mb-2">
                                <span class="d-flex text-muted fw-light"> 
                                    <p class="breadcrumb-item pageHeader active me-2 mb-0" aria-current="page" onClick={() => navigate(`/quiz`)}> Quiz </p> / <b className='mx-2'> {isEdit ? 'Edit' : "Add"} </b>
                                </span>
                            </h4>
                            <Link to="/quiz" class="btn btn-secondary">⬅ Go Back</Link>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card mb-4">
                                    <div class="card-body">
                                        <form onSubmit={handleSubmit(onSubmit)}>
                                            <div class="row mb-3">
                                                <div class="col-md-3 mb-3">
                                                    <label class="form-label">Name</label>
                                                    <input type="text" name="quizName" class="form-control" {...register("quizName")} />
                                                    <small className="text-danger">{errors.quizName?.message}</small>
                                                </div>
                                                <div class="col-md-3 mb-3">
                                                    <label class="form-label">Description</label>
                                                    <input type="text" name="quizDescription" class="form-control" {...register("quizDescription")} />
                                                    <small className="text-danger">{errors.quizDescription?.message}</small>
                                                </div>
                                                <div class="col-md-3 mb-3">
                                                    <label class="form-label">Subtitle</label>
                                                    <input type="text" name="subtitle" class="form-control" {...register("subtitle")} />
                                                    <small className="text-danger">{errors.subtitle?.message}</small>
                                                </div>
                                                <div class="col-md-3 mb-3">
                                                    <label class="form-label">Status</label>
                                                    <div class="form-check form-switch mb-2">
                                                        <input class="form-check-input mt-2" name="isActive" type="checkbox" id="flexSwitchCheckDefault" {...register("isActive")} />
                                                    </div>
                                                </div>
                                                {quizData?.thumbnail ? (
                                                    <div class="col-md-3 mb-3">
                                                        <label class="form-label">Thumbnail</label>
                                                        <br />
                                                        <div class="mt-3">
                                                            <div class="d-inline-block ">
                                                                <div class="position-relative " style={{ width: "fit-content;" }}>
                                                                    <a target="_blank">
                                                                        <img src={`${process.env.REACT_APP_BASE_URL}/${quizData?.thumbnail}`} id="existingImagePhoto" class="img-thumbnail" />
                                                                    </a>
                                                                    <button type="button" class="btn btn-danger btn-sm position-absolute top-0 end-0" onClick={() => confirmDeleteDailog()}> &times; </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div class="col-md-3 mb-3">
                                                        <label class="form-label">Upload Thumbnail</label>
                                                        <br />
                                                        <div>
                                                            <input type="file" accept=".jpeg, .jpg, .png, .webp" name="thumbnail" {...register("thumbnail")} class="form-control" />
                                                        </div>
                                                        <small className="text-danger">{errors.thumbnail?.message}</small>
                                                        {previewImage?.[0] && (
                                                            <div class="mt-1">
                                                                <div class="d-inline-block ">
                                                                    <div class="position-relative " style={{ width: "fit-content;" }}>
                                                                        <a target="_blank">
                                                                            <img src={URL.createObjectURL(previewImage[0])} id="existingImagePhoto" class="img-thumbnail" />
                                                                        </a>
                                                                        <button type="button" class="btn btn-danger btn-sm position-absolute top-0 end-0" onClick={() => resetField('thumbnail')}> &times; </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                )
                                                }
                                            </div>
                                            <div class="mt-4">
                                                <button type="submit" class="btn btn-primary me-3">Save</button>
                                                <button type="button" onClick={() => resetValue()} class="btn btn-secondary reset-btn">Reset</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default AddQuiz
